<template>
	<div class="bg-white px-3 index">
		<el-tabs v-model="tabIndex" @tab-click="handleClick">
			<el-tab-pane :label="tab.name" :key="tabI" v-for="(tab, tabI) in tabbars"></el-tab-pane>
		</el-tabs>

		<button-search ref="buttonSearch" placeholder="要搜索的订单编号" @search="searchEvent">
			<!-- 左边 -->
			<template #left>
				<el-button type="success" size="mini" @click="exportModal = true">导出数据</el-button>
				<el-button type="danger" size="mini" @click="deleteAll(1)">批量删除</el-button>
			</template>
			<!-- 高级搜索表单 -->
			<template #form>
				<el-form inline ref="form" :model="form" label-width="80px">
					<el-form-item label="订单编号" class="mb-0">
						<el-input v-model="form.no" placeholder="订单编号" size="mini"></el-input>
					</el-form-item>
					<el-form-item label="下单时间" class="mb-0">
						<el-date-picker size="small" v-model="form.time" type="daterange" range-separator="至"
							start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
						</el-date-picker>
					</el-form-item>

					<el-form-item label="收货人" class="mb-0">
						<el-input v-model="form.name" placeholder="收货人" size="mini"></el-input>
					</el-form-item>
					<el-form-item label="手机号" class="mb-0">
						<el-input v-model="form.phone" placeholder="手机号" size="mini"></el-input>
					</el-form-item>
					<el-form-item class="mb-0">
						<el-button type="info" size="mini" @click="searchEvent">
							搜索</el-button>
						<el-button size="mini" @click="clearSearch">清空筛选条件</el-button>
					</el-form-item>
				</el-form>
			</template>
		</button-search>

		<el-table border class="mt-3" :data="tableData" style="width: 100%" @selection-change="handleSelectionChange"
			:height="heights">
			<el-table-column type="selection" width="45" align="center">
			</el-table-column>

			<el-table-column label="商品" width="600">
				<template slot-scope="scope">
					<div class="d-flex">
						<div style="flex: 1">
							<p class="mb-1">订单编号：</p>
							<p class="mb-1">
								<small>{{ scope.row.no }}</small>
							</p>
						</div>
						<div style="flex: 1">
							<p class="mb-1">下单时间：</p>
							<p class="mb-1">
								<small>{{ scope.row.create_time }}</small>
							</p>
						</div>
					</div>
					<div class="media border-top py-2" v-for="(item, index) in scope.row.order_items" :key="index">
						<div v-if="item.goods_item" class="pic_b">
							<div class="u-f u-ac u-jsb">
								<div class="u-f u-ac">
									<img class="mr-3" style="width: 60px; height: 60px" v-if="item.goods_item.cover"
										:src="item.goods_item.cover[0].url" />
									<span class="goods_gg">{{ item.skusTextArr }} ×{{ item.num }}</span>
								</div>
								<div class="is_tk" v-if="scope.row.closed != 1">
									<div v-if="item.refund_status != 'pending'">
										{{ item.refund_status_text }}
									</div>
									<div v-if="
                      item.refund_status == 'pending' && scope.row.paid_time
                    " class="color_red">
										{{ item.ship_status_text }}
									</div>
									<div v-else-if="
                      item.refund_status == 'pending' && !scope.row.paid_time
                    " class="color_red">
										未付款
									</div>

									<el-button type="danger" @click="tk_clisk(scope.row, item)"
										v-if="item.refund_status == 'applied'" size="mini" round>退款处理</el-button>
									<span v-if="item.refund_status == 'agree'" style="color: red">已同意退款</span>
									<el-button type="danger" @click="qr_tk_clisk(scope.row, item)"
										v-if="item.refund_status == 'wait'" size="mini" round>确认收货并退款</el-button>
									<el-button @click="tk_jh_wl(scope.row, item)" v-if="item.refund_status == 'wait'"
										size="mini" round>
										退款寄回物流</el-button>

									<el-button type="text" size="mini" @click="ship(item)" v-if="
                      scope.row.paid_time &&
                      item.ship_status === 'pending' &&
                      (item.refund_type == 0 || !item.refund_type)
                    ">
										订单发货</el-button>
									<el-button type="text" size="mini" v-if="
                      item.ship_status === 'delivered' &&
                      scope.row.closed === 0 &&
                      scope.row.payment_method &&
                      item.refund_status === 'pending' &&
                      (item.refund_type == 0 || !item.refund_type)
                    " @click="wlDetail(item)">物流信息</el-button>
								</div>
							</div>
							<div class="media-body">
								<div class="mt-0">
									<a class="text-primary">{{ item.goods_item.title }}</a>
								</div>
							</div>
							<div class="shjlbtn_b">
								<div class="sh_jl" @click="getshjl(item)">售后记录</div>
							</div>
						</div>
						<span class="text-muted" v-else>该商品已被删除</span>
					</div>
				</template>
			</el-table-column>
			<el-table-column align="center" width="120" label="实付款">
				<template slot-scope="scope">
					<span>￥{{ scope.row.total_price }}</span>
					<p><small>(含运费：￥0.00)</small></p>
				</template>
			</el-table-column>
			<el-table-column align="center" label="买家">
				<template slot-scope="scope">
					<div class="tx_pic" :style="'background:url(' + scope.row.user_avatar + ')'"></div>
					<!-- <el-avatar shape="square" :size="100" fit="contain"  :src="scope.row.user_avatar"></el-avatar> -->
					<span>{{ scope.row.user_name }}</span>
					<p>
						<small>(用户id：{{ scope.row.user_id }})</small>
					</p>
				</template>
			</el-table-column>
			<el-table-column prop="status" align="center" label="支付方式" width="150">
				<template slot-scope="scope">
					<span class="badge badge-success" v-if="scope.row.payment_method === 'wechat'">微信支付</span>
					<span class="badge badge-primary" v-else-if="scope.row.payment_method === 'alipay'">支付宝支付</span>
					<span class="badge badge-primary" v-else-if="scope.row.payment_method === 'point'">积分兑换</span>
					<span class="badge badge-secondary" v-else>未支付</span>
				</template>
			</el-table-column>
			<!-- <el-table-column align="center" label="配送方式" width="300">
				<template slot-scope="scope">
					<div v-if="scope.row.ship_data">
						<div>{{scope.row.ship_data.express_company}}</div>
						<div>{{scope.row.ship_data.express_no}}</div>
					</div>
					<span class="badge badge-secondary" v-else>未配送</span>
				</template>
			</el-table-column> -->
			<el-table-column align="center" width="170" label="交易状态">
				<template slot-scope="scope">
					<div>
						付款状态:
						<span class="badge" :class="
                scope.row.payment_method ? 'badge-success' : 'badge-secondary'
              ">{{ scope.row.payment_method ? "已付款" : "未付款" }}</span>
					</div>
				</template>
			</el-table-column>
			<el-table-column align="center" width="170" label="订单状态">
				<template slot-scope="scope">
					<div>
						<span class="badge" :class="
                scope.row.closed == 0 ? 'badge-success' : 'badge-secondary'
              ">{{ { 0: "正常", 1: "已关闭" }[scope.row.closed] }}</span>
					</div>
				</template>
			</el-table-column>
			<el-table-column align="center" label="操作" width="150">
				<template slot-scope="scope">
					<el-button type="text" size="mini" @click="orderDetail(scope.row)">订单详情</el-button>
					<!-- <el-button type="text" size="mini"
						v-if="scope.row.ship_status ==='delivered' && scope.row.closed === 0 && scope.row.payment_method && scope.row.refund_status === 'pending'"
						@click="wlDetail(scope.row)">物流信息</el-button> -->
					<!-- <el-button type="text" size="mini" @click="ship(scope.row)"
						v-if="scope.row.ship_status ==='pending' && scope.row.closed === 0 && scope.row.payment_method && scope.row.refund_status === 'pending'">
						订单发货</el-button> -->
				</template>
			</el-table-column>
		</el-table>
		<div style="height: 60px"></div>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white"
			style="bottom: 0; left: 200px; right: 0; z-index: 100">
			<div style="flex: 1" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper" :total="page.total" @size-change="handleSizeChange"
					@current-change="handleCurrentChange">
				</el-pagination>
			</div>
		</el-footer>

		<el-dialog title="订单发货" :visible.sync="shipModal" width="30%">
			<el-form :model="shipForm" ref="ruleForm">
				<el-form-item label="快递公司" prop="express_company">
					<el-select v-model="shipForm.express_company" placeholder="请选择">
						<el-option v-for="(item, index) in express_company_options" :key="index" :label="item.name"
							:value="item.name">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="快递单号" prop="express_no">
					<el-input type="text" v-model="shipForm.express_no"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="shipModal = false">取 消</el-button>
				<el-button type="primary" @click="shipSubmit">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 订单详情 -->
		<el-dialog title="订单详情" :visible.sync="orderdetaildialog" top="20px" width="50%" @close="closeorderDetailwl">
			<el-form :model="orderForm" ref="ruleForm" label-width="100px" v-loading="orderLoading">
				<el-form-item label="商品:">
					<div class="u-f u-wrap">
						<div v-for="(good, index) in orderForm.orderItems" :key="index" class="items">
							<div class="items_inner">
								<img v-if="good.goodsItem" :src="good.goodsItem.cover[0].url" alt="" />
								<el-tooltip class="" v-if="good.goodsItem" effect="dark" :content="good.goodsItem.title"
									placement="bottom">
									<div class="g_tit">{{ good.goodsItem.title }}</div>
								</el-tooltip>
								<el-tooltip class="item" v-if="good.skusText" effect="dark" :content="good.skusText"
									placement="bottom">
									<div class="gg">规格:{{ good.skusText }}</div>
								</el-tooltip>

								<div class="g_price">￥{{ good.price }}×{{ good.num }}</div>
								<div v-if="good.ship_data" class="kd">
									{{ good.ship_data.express_company }}
								</div>
								<div v-if="good.ship_data" class="kd">
									{{ good.ship_data.express_no }}
								</div>
							</div>
						</div>
					</div>
				</el-form-item>
				<el-form-item label="总价:">
					<div>
						￥<span v-if="total_priceType == 0">{{ orderForm.total_price }}</span>
						<el-input v-model="total_priceValue" :placeholder="orderForm.total_price" style="width: 100px"
							size="mini" v-if="total_priceType == 1"></el-input>
						<el-button type="text" size="mini" style="margin-left: 5px" @click="total_priceType = 1"
							v-if="!orderForm.payment_method&&orderForm.closed==0&&total_priceType==0">修改</el-button>
						<el-button type="success" size="mini" style="margin-left: 5px"
							@click="updateTotal_price(orderForm)" v-if="total_priceType == 1">确认</el-button>
						<el-button size="mini" style="margin-left: 5px" @click="total_priceType = 0"
							v-if="total_priceType == 1">取消
						</el-button>
					</div>
				</el-form-item>
				<el-form-item label="收货信息:" v-if="orderForm.address">
					<span class="shxx">{{ orderForm.address.name }}</span>
					<span class="shxx">{{ orderForm.address.phone }}</span>
					<span class="shxx">{{ orderForm.address.province }}/{{ orderForm.address.city }}/{{
              orderForm.address.district
            }}{{ orderForm.address.address }}</span>
				</el-form-item>
				<el-form-item label="订单号:">
					<div>
						{{ orderForm.no }}
					</div>
				</el-form-item>
				<el-form-item label="订单状态:">
					<div :class="orderForm.closed == 0 ? 'o_state' : 'o_state2'">
						{{ { 0: "正常", 1: "关闭" }[orderForm.closed] }}
					</div>
				</el-form-item>
				<el-form-item label="支付信息:">
					<span class="shxx">支付金额：<span
							:class="orderForm.closed == 0 ? 'o_state' : 'o_state2'">￥{{ orderForm.pay_amount }}</span>
					</span>
					<span class="shxx">支付时间：<span :class="orderForm.closed == 0 ? 'o_state' : 'o_state2'">{{
                orderForm.paid_time
                  ? date("Y-m-d H:i:s", orderForm.paid_time)
                  : "未支付"
              }}</span></span>
					<span class="shxx">支付积分：<span
							:class="orderForm.closed == 0 ? 'o_state' : 'o_state2'">{{ orderForm.pay_kcurrency }}</span></span>
					<span class="shxx">支付类型：<span
							:class="orderForm.closed == 0 ? 'o_state' : 'o_state2'">{{ orderForm.payment_method }}</span></span>
				</el-form-item>
				<el-form-item label="使用优惠券:">
					<div v-if="orderForm.couponUserItem">
						{{
              orderForm.couponUserItem.coupon
                ? orderForm.couponUserItem.coupon.name
                : "未使用优惠券"
            }}
					</div>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="orderdetaildialog = false">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 物流信息 -->
		<el-dialog title="物流信息" :visible.sync="wldetaildialog" top="20px" width="50%" @close="closeorderDetail">
			<div class="top_kk_b u-f u-ac">
				<div class="kk1">
					<img :src="wldata.logo" alt="" />
				</div>
				<div class="kk2">
					<div class="kk_name">{{ wldata.typename }}</div>
					<div class="kk_num">{{ wldata.number }}</div>
				</div>
			</div>
			<div class="wl_box" v-loading="wlloading">
				<el-timeline>
					<el-timeline-item v-for="(activity, index) in allwldetail" :key="index" :timestamp="activity.time"
						:color="index == 0 ? '#0bbd87' : ''">
						{{ activity.status }}
					</el-timeline-item>
				</el-timeline>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="wldetaildialog = false">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="导出数据" :visible.sync="exportModal" width="40%">
			<el-form :model="exportForm" ref="ruleForm">
				<el-form-item label="订单类型" prop="tab">
					<el-select v-model="exportForm.tab" placeholder="请选择">
						<el-option v-for="(item, index) in tabbars" :key="index" :label="item.name" :value="item.key">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="时间范围" prop="time">
					<el-date-picker size="small" v-model="exportForm.time" type="daterange" range-separator="至"
						start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
					</el-date-picker>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="exportModal = false">取 消</el-button>
				<el-button type="primary" @click="exportExcel">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 退款处理 -->
		<el-dialog title="退款处理" :visible.sync="tk_dialog" width="40%">
			<el-form :model="tkForm" ref="ruleForm" label-width="100px" :rules="rules">
				<el-form-item label="服务类型">
					<span style="color: red">{{
            { 1: "退货退款", 2: "仅退款" }[tk_data.refund_type]
          }}</span>
				</el-form-item>
				<el-form-item label="退款理由">
					<span style="color: red">{{
            tk_data ? tk_data.refund_extra.refund_reason : ""
          }}</span>
				</el-form-item>
				<el-form-item label="是否同意" prop="tab">
					<el-radio-group v-model="tkForm.agree">
						<el-radio :label="0">不同意</el-radio>
						<el-radio :label="2" :disabled="tk_data.refund_type == 2">同意退款</el-radio>
						<el-radio :label="1" :disabled="tk_data.refund_type == 1">直接退款</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="" v-if="tkForm.agree == 1">
					<span style="color: red">(金额将直接退回至支付账户中)</span>
				</el-form-item>
				<el-form-item label="拒绝理由" prop="disagree_reason" v-if="tkForm.agree == 0">
					<el-input v-model="tkForm.disagree_reason" placeholder="请输入拒绝理由" type="textarea" size="small">
					</el-input>
				</el-form-item>
				<div v-if="tkForm.agree == 2">
					<el-form-item label="收件人" prop="addressee">
						<el-input v-model="tkForm.addressee" placeholder="请输入收件人" size="small"></el-input>
					</el-form-item>
					<el-form-item label="收货地址" prop="return_address">
						<el-input v-model="tkForm.return_address" placeholder="请输入收货地址" size="small"></el-input>
					</el-form-item>
					<el-form-item label="联系电话" prop="phone">
						<el-input v-model="tkForm.phone" placeholder="请输入联系电话" size="small"></el-input>
					</el-form-item>
					<el-form-item label="退款说明备注">
						<el-input v-model="tkForm.return_explain" placeholder="请输入退款说明备注" type="textarea" size="small">
						</el-input>
					</el-form-item>
				</div>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="tk_dialog = false">取 消</el-button>
				<el-button type="primary" @click="tk_submit('ruleForm')">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 售后记录 -->
		<el-dialog title="售后记录" :visible.sync="sh_dialog" width="40%" top="80px">
			<div class="wl_box" v-loading="shloading">
				<el-timeline>
					<el-timeline-item v-for="(activity, index) in shlists" :key="index"
						:timestamp="activity.create_time">
						{{ activity.op_user }}：
						<div v-for="(r, index) in activity.refund_details" :key="index">
							{{ r }}
						</div>
					</el-timeline-item>
				</el-timeline>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="sh_dialog = false">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import buttonSearch from "@/components/common/button-search.vue";
	import common from "@/common/mixins/common.js";
	export default {
		mixins: [common],
		inject: ["layout"],
		components: {
			buttonSearch,
		},
		data() {
			return {
				preUrl: "order",
				//价格输入框
				total_priceValue: "",
				//修改价格判断
				total_priceType: 0,
				tabIndex: 0,
				tabbars: [{
						name: "全部",
						key: "all",
					},
					{
						name: "待付款",
						key: "nopay",
					},
					{
						name: "待发货",
						key: "noship",
					},
					{
						name: "已发货",
						key: "shiped",
					},
					{
						name: "已收货",
						key: "received",
					},
					{
						name: "已完成",
						key: "finish",
					},
					{
						name: "已关闭",
						key: "closed",
					},
					{
						name: "退款中",
						key: "refunding",
					},
				],
				form: {
					no: "",
					time: "",
					name: "",
					phone: "",
				},
				tableData: [],

				shipModal: false,
				shipForm: {
					express_company: "",
					express_no: "",
				},
				shipId: 0,
				express_company_options: [],

				exportModal: false,
				exportForm: {
					tab: "",
					time: "",
				},
				orderdetaildialog: false,
				orderForm: {},
				date: xaoi.date,
				orderLoading: false,
				wldetaildialog: false,
				allwldetail: "",
				wlloading: false,
				wldata: "",
				tk_dialog: false,
				tkForm: {
					addressee: "",
					disagree_reason: "",
					agree: 0,
					return_address: "",
					phone: "",
					return_explain: "",
				},
				rules: {
					disagree_reason: [{
						required: true,
						message: "请填写拒绝理由",
						trigger: "blur",
					}, ],
					addressee: [{
						required: true,
						message: "请填写收货人",
						trigger: "blur",
					}, ],
					return_address: [{
						required: true,
						message: "请填写收货地址",
						trigger: "blur",
					}, ],
					phone: [{
						required: true,
						message: "请填写联系电话",
						trigger: "blur",
					}, ],
				},
				tk_id: "",
				tk_data: "",
				shlists: [],
				sh_dialog: false,
				shloading: false,
				heights: null,
				row: "",
			};
		},
		computed: {
			tab() {
				return this.tabbars[this.tabIndex].key;
			},
			params() {
				let str = "";
				for (let key in this.form) {
					let val = this.form[key];
					if (val) {
						if (Array.isArray(val)) {
							str += `&starttime=${val[0]}`;
							str += `&endtime=${val[1]}`;
						} else {
							str += `&${key}=${this.form[key]}`;
						}
					}
				}
				return str;
			},
		},
		created() {
			this.axios
				.get("/admin/express_company/1?limit=50", {
					token: true,
				})
				.then((res) => {
					let data = res.data.data;
					this.express_company_options = data.list;
				});
		},
		watch: {
			"tkForm.agree"(nval, oval) {
				if (nval == 0) {
					this.tkForm.addressee = "";
					this.tkForm.return_address = "";
					this.tkForm.phone = "";
					this.tkForm.return_explain = "";
				}
				if (nval == 1) {
					this.tkForm.addressee = "";
					this.tkForm.return_address = "";
					this.tkForm.phone = "";
					this.tkForm.return_explain = "";
					this.tkForm.disagree_reason = "";
				}
				if (nval == 2) {
					this.tkForm.disagree_reason = "";
				}
			},
		},
		mounted() {
			this.getHeight();
		},
		methods: {
			// 获取高度
			getHeight() {
				let that = this;
				that.heights = window.innerHeight - 310 + "px";
				window.onresize = () => {
					that.heights = window.innerHeight - 310 + "px";
				};
			},
			tk_submit(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						this.axios
							.post(
								"/admin/order/handle_refund", {
									id: this.tk_id,
									agree: this.tkForm.agree,
									disagree_reason: this.tkForm.disagree_reason,
									addressee: this.tkForm.addressee,
									return_address: this.tkForm.return_address,
									return_explain: this.tkForm.return_explain,
									phone: this.tkForm.phone,
								}, {
									token: true,
								}
							)
							.then((res) => {
								if (res.data.code == 200) {
									this.$message.success("操作成功");
									this.tk_dialog = false;
									this.getList();
								} else {
									this.$message.error(res.data.msg);
								}
							});
					} else {
						console.log("error submit!!");
						return false;
					}
				});
			},
			//修改价格
			updateTotal_price(val) {
				if (this.total_priceValue<0.01) return this.$message('最小价格为0.01元')
				this.axios
					.post(
						"/admin/order/setPrice", {
							id: val.id,
							total_price: this.total_priceValue,
						}, {
							token: true,
						}
					)
					.then((res) => {
						if (res.data.code == 200) {
							this.$message.success("操作成功");
							this.orderdetaildialog = false
						} else {
							this.$message.error(res.data.msg);
						}
					});
			},
			// 导出数据
			exportExcel() {
				if (!this.exportForm.tab) {
					return this.$message({
						type: "error",
						message: "订单类型不能为空",
					});
				}
				let url = `/admin/order/excelexport?tab=${this.exportForm.tab}`;
				let params = "";
				let val = this.exportForm.time;
				if (val && Array.isArray(val)) {
					params += `&starttime=${val[0]}`;
					params += `&endtime=${val[1]}`;
				}
				this.layout.showLoading();
				this.axios
					.post(
						url + params, {}, {
							token: true,
							responseType: "blob",
						}
					)
					.then((res) => {
						this.exportModal = false;
						if (res.status == 200) {
							let url = window.URL.createObjectURL(new Blob([res.data]));
							let link = document.createElement("a");
							link.style.display = "none";
							link.href = url;
							let filename = new Date().getTime() + ".xlsx";
							link.setAttribute("download", filename);
							document.body.appendChild(link);
							link.click();
						}
						this.layout.hideLoading();
					})
					.catch((err) => {
						this.layout.hideLoading();
					});
			},
			// 获取请求列表分页url
			getListUrl() {
				return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}&tab=${this.tab}${this.params}`;
			},
			// 处理获取列表结果
			getListResult(e) {
				this.tableData = e.list;
			},
			// 加载数据
			handleClick(tab, event) {
				this.getList();
			},
			// 清空筛选条件
			clearSearch() {
				this.form = {
					no: "",
					time: "",
					name: "",
					phone: "",
				};
			},
			// 搜索事件
			searchEvent(e = false) {
				// 简单搜索
				if (typeof e === "string") {
					this.form.no = e;
					this.getList();
					return;
				}
				// 高级搜索
				this.getList();
			},
			ship(item) {
				this.shipId = item.id;
				this.shipForm.express_company=''
				this.shipForm.express_no=''
				this.shipModal = true;
			},
			shipSubmit() {
				this.layout.showLoading();
				this.axios
					.post(
						"/admin/orderItem/orderItemsShip", {
							...this.shipForm,
							id: this.shipId,
						}, {
							token: true,
						}
					)
					.then((res) => {
						this.shipModal = false;
						this.$message({
							type: "success",
							message: "发货成功",
						});
						this.getList();
						this.layout.hideLoading();
					})
					.catch((err) => {
						this.layout.hideLoading();
					});
			},
			orderDetail(row) {
				this.orderLoading = true;
				this.axios
					.get(`/admin/pc/order/${row.id}`, {
						token: true,
					})
					.then((res) => {
						this.orderForm = res.data.data;
						this.orderLoading = false;
					});
				this.orderdetaildialog = true;
			},
			closeorderDetail() {
				this.orderForm = {};
			},
			closeorderDetailwl() {
				this.allwldetail = "";
				this.total_priceType = 0
			},
			wlDetail(row) {
				this.wldetaildialog = true;
				this.wlloading = true;
				this.axios
					.get(`/admin/pc/orderItem/get_ship_info?id=${row.id}`, {
						token: true,
					})
					.then((res) => {
						this.wlloading = false;
						if (res.data.code == 200) {
							this.allwldetail = res.data.data.result.list;
							this.wldata = res.data.data.result;
						} else {
							this.wldetaildialog = false;
							this.$message.error(res.data.msg);
						}
					});
			},
			tk_jh_wl(row, item) {
				this.wldetaildialog = true;
				this.wlloading = true;
				this.axios
					.get(`/admin/pc/orderItem/get_ship_info?id=${item.id}`, {
						token: true,
					})
					.then((res) => {
						this.wlloading = false;
						if (res.data.code == 200) {
							this.allwldetail = res.data.data.result.list;
							this.wldata = res.data.data.result;
						} else {
							this.wldetaildialog = false;
							this.$message.error(res.data.msg);
						}
					});
			},
			tk_clisk(data, item) {
				this.tk_id = item.id;
				this.tk_data = item;
				this.tkForm = {
					addressee: "",
					disagree_reason: "",
					agree: 0,
					return_address: "",
					phone: "",
					return_explain: "",
				};
				this.tk_dialog = true;
			},
			qr_tk_clisk(data, item) {
				this.$confirm("此操作将确认收到寄回货物并退款, 是否继续?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(() => {
						this.axios
							.post(
								"/admin/order/handle_refund", {
									id: item.id,
									agree: 1,
								}, {
									token: true,
								}
							)
							.then((res) => {
								if (res.data.code == 200) {
									this.$message.success("操作成功");
									this.getList();
								} else {
									this.$message.error(res.data.msg);
								}
							});
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "已取消删除",
						});
					});
			},
			async getshjl(item) {
				this.shloading = true;
				this.sh_dialog = true;
				let res = await this.ajax("orderItem/RefundHistory", {
					order_item_id: item.id,
				});
				this.shlists = res.data.list;
				this.shloading = false;
			},
		},
	};
</script>

<style lang="scss" scoped>
	.el-form-item {
		margin: 0;
	}

	.items {
		width: 25%;

		.items_inner {
			width: 95%;

			.kd {
				line-height: normal;
				color: #008000;
			}

			.gg {
				line-height: normal;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				padding: 3px 0;
			}
		}

		img {
			width: 100%;
			display: block;
			border-radius: 3px;
		}

		.g_price {
			line-height: normal;
			color: red;
		}

		.g_tit {
			color: rgb(0, 0, 0);
			line-height: normal;
			font-size: 13px;
			text-overflow: -o-ellipsis-lastline;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			line-clamp: 2;
			-webkit-box-orient: vertical;
		}
	}

	.shxx {
		margin-right: 10px;
	}

	.o_state {
		color: green;
	}

	.o_state2 {
		color: red;
	}

	.wl_box {
		max-height: 600px;
		overflow: auto;
	}

	.top_kk_b {
		padding: 0 0 10px 40px;

		.kk1 {
			width: 60px;
			height: 60px;
			border-radius: 50%;
			overflow: hidden;

			img {
				width: 100%;
				display: block;
			}
		}

		.kk2 {
			margin-left: 10px;

			.kk_name {}

			.kk_num {}
		}
	}

	.pic_b {
		width: 100%;

		.goods_gg {
			font-size: 12px;
		}

		.is_tk {
			display: flex;
			align-items: flex-end;
			flex-direction: column;
		}
	}

	.color_red {
		color: red;
	}

	.tx_pic {
		width: 100px;
		height: 100px;
		margin: 0 auto;
		border-radius: 4px;
		background-repeat: no-repeat !important;
		background-size: cover !important;
		background-position: center !important;
	}

	.shjlbtn_b {
		display: flex;
		justify-content: flex-end;

		.sh_jl {
			border: 1px solid #666;
			color: #666;
			border-radius: 20px;
			padding: 0px 4px;
			font-size: 12px;
			cursor: pointer;
		}
	}
</style>